import React, { useEffect, useRef, useState } from 'react';
import { default as __ } from '../../utils';
import { colors } from '../../styles';
import Shape from '../utils/shape';
import Pinned from '../utils/pinned';

function Base({
  cb = __.noop(),
  shapeless = false,
  variant = 'team',
  shade = colors.black,
  xs = false,
  xl = false,
}) {
  return (
    <div style={{ position: 'relative' }} onClick={cb}>
      {!shapeless &&
        {
          you: (
            <Pinned tag="div">
              <Shape.Ennea size={24} fill="var(--accent)" />
            </Pinned>
          ),
          rivals: (
            <Pinned tag="div">
              <Shape.Hexa size={24} fill="var(--accent)" />
            </Pinned>
          ),
          team: (
            <Pinned tag="div">
              <Shape.Ennea size={24} fill="var(--accent)" />
            </Pinned>
          ),
        }[variant]}

      <svg
        viewBox={`0 ${xl ? -4 : 0} 120 70`}
        width="120"
        height="70"
        style={{
          transformOrigin: 'center',
          transform: `scale(${xl ? 2 : xs ? 0.5 : 1})`,
        }}
      >
        <g>
          <rect x="30" y="0" width="60" height="70" fill={shade} />
          <rect x="0" y="0" width="30" height="26" fill={shade} />
          <rect x="90" y="0" width="30" height="26" fill={shade} />
        </g>
      </svg>
    </div>
  );
}

const Avatar = {
  Regular: props => <Base {...props} />,
  Small: props => <Base xs {...props} />,
  Big: props => <Base xl {...props} />,
};

export default Avatar;
